import React from 'react';
import { Collapse } from 'antd';
import { CalendarDays } from 'lucide-react';
import { Calendar, StatusTag } from '../../../common';
import { User } from '../../../../data';

/** Collapsible header used by the profile's Calendario / Recorrido blocks. */
export function PanelHeader({ icon, title, count }) {
    return (
        <div className="flex items-center gap-2.5">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-surface-100 text-sm text-surface-600">{icon}</span>
            <span className="text-[15px] font-semibold text-surface-900">{title}</span>
            {count}
        </div>
    );
}

function PromoterCalendar({ promotor, calendars, stores, createCalendar, isOpen, setIsOpen, calendarLoading }) {
    const isClientUser = User.getInstance()?.userType === 'client';

    return (
        <div className="shelf-card overflow-hidden">
            <Collapse
                ghost
                items={[
                    {
                        key: 1,
                        styles: { body: { padding: '4px 20px 20px' } },
                        label: (
                            <PanelHeader
                                icon={<CalendarDays />}
                                title={<span>Calendario</span>}
                                count={<StatusTag tone="brand">{calendars?.length || 0} días asignados</StatusTag>}
                            />
                        ),
                        children: (
                            <Calendar
                                calendars={calendars}
                                promotor={promotor}
                                allStores={stores}
                                createCalendar={createCalendar}
                                isOpen={isOpen}
                                setIsOpen={setIsOpen}
                                isUpdating={calendarLoading}
                                readonly={isClientUser}
                            />
                        )
                    }
                ]}
            />
        </div>
    );
}

export default PromoterCalendar;
